<template>
  <div class="page-wrap text-center">
    <div class="session-form-hold">
      <base-card>
        <v-card-text>
          <img
            v-if="$vuetify.theme.dark"
            class="mb-4"
            height="50"
            src="/img/logo/logo-dark.png"
            alt=""
          />
          <img
            v-else
            class="mb-4"
            height="50"
            src="/img/logo/logo-light.png"
            alt=""
          />

          <template v-if="available">
            <h5 class="text-center">Chave de segurança</h5>
            <h6 class="text--disabled text-center font-weight-medium mb-10">
              Clique no botão para cadastrar a chave de segurança
            </h6>

            <template v-if="!credential">
              <v-scroll-y-transition v-if="error">
                <v-alert type="error">
                  {{ error }}
                </v-alert>
              </v-scroll-y-transition>

              <v-btn color="primary" block :loading="loading" @click="process">
                Cadastrar
              </v-btn>
            </template>
            <template v-else-if="!success">
              <v-text-field
                dense
                outlined
                label="Nome do dispositivo"
                v-model="name"
              ></v-text-field>
              <v-alert v-if="error" type="error">
                {{ error }}
              </v-alert>

              <v-btn color="primary" block :loading="loading" @click="register">
                Salvar
              </v-btn>
            </template>

            <template v-else>
              <v-alert type="success">
                Chave de segurança cadastrada com sucesso!
              </v-alert>
            </template>
          </template>
          <template v-else>
            <v-alert type="error">
              Seu navegador não suporta a o cadastro de chave de segurança
            </v-alert>
          </template>
          <v-btn
            class="mt-2"
            text
            small
            block
            @click="goBack"
            :disabled="loading"
            >Voltar</v-btn
          >
        </v-card-text>
      </base-card>
    </div>
  </div>
</template>
<script>
import ReCaptcha from "@/components/global/ReCaptcha.vue";
import WEBAUTHN from "@/services/account/webauthn";
import { mapGetters } from "vuex";
import platform from "platform";

export default {
  components: { ReCaptcha },
  name: "WebAuthnRegister",
  metaInfo: {
    title: "Chave de segurança",
    script: [
      {
        src: "https://cdn.jsdelivr.net/npm/@simplewebauthn/browser@10.0.0/dist/bundle/index.umd.min.js",
        async: true,
      },
    ],
  },
  data() {
    return {
      loading: false,
      error: false,
      success: false,
      available: false,
      credential: null,
      name: "",
    };
  },
  methods: {
    async process() {
      try {
        this.error = false;
        this.loading = true;
        const { startRegistration } = SimpleWebAuthnBrowser;
        const { options } = await WEBAUTHN.register.getOptions();
        const credential = await startRegistration(options);
        this.credential = credential;

        const plat = platform.parse(navigator.userAgent);
        this.name = plat.os.family;
      } catch (e) {
        console.error(e);
        this.error = e.message;
      } finally {
        this.loading = false;
      }
    },
    async register() {
      try {
        this.error = false;
        this.loading = true;
        const response = await WEBAUTHN.register.save({
          name: this.name,
          credential: this.credential,
        });
        this.success = true;
      } catch (e) {
        console.error(e);
        this.error = e.message;
      } finally {
        this.loading = false;
      }
    },
    goBack() {
      this.$router.push("/");
    },
  },
  computed: {
    ...mapGetters("auth", ["user"]),
  },
  mounted() {
    this.available = !!window.PublicKeyCredential;
  },
};
</script>
<style lang="scss" scoped>
.page-wrap {
  background: radial-gradient(
      circle at 50% 50%,
      rgba(0, 0, 0, 50%) 0%,
      rgba(0, 0, 0, 90%) 90vw
    ),
    url(/img/logo/auth-background.png), black;
  display: flex;
  background-size: cover;
  background-position: center;
  align-items: center;
  padding: 40px 1rem;
  height: 100%;
  min-height: 100vh;
}
.session-form-hold {
  width: 100%;
  max-width: 400px;
  margin: 0 auto;
}
</style>
